const COLS = [
  ["Received", "created_at"],
  ["Status", "status"],
  ["Name", "name"],
  ["Email", "email"],
  ["Phone", "phone"],
  ["Organisation", "organisation"],
  ["Message", "message"],
];

const cell = (v) => {
  let s = String(v ?? "");
  if (/^[=+\-@\t\r]/.test(s) && !/^[+\-]?[\d\s()-]+$/.test(s)) s = `'${s}`; // stop spreadsheet apps running it as a formula (phone numbers left as-is)
  return `"${s.replace(/"/g, '""')}"`;
};

const fmt = (iso) => {
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString("en-AU", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export const downloadEnquiriesCsv = (items, label) => {
  const rows = items.map((e) => COLS.map(([, k]) => cell(k === "created_at" ? fmt(e[k]) : k === "status" ? e.status || "new" : e[k])).join(","));
  const csv = "\uFEFF" + [COLS.map(([h]) => cell(h)).join(","), ...rows].join("\r\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `enquiries-${label}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
